module.exports = __webpack_public_path__ + "img/level-1.558918cc.svg";